import React from 'react';

interface HowItWorksProps {
  onBack: () => void;
}

const HowItWorks: React.FC<HowItWorksProps> = ({ onBack }) => {
  // Just call onBack without changing the URL
  const handleBackClick = () => {
    onBack();
  };

  return (
    <div className="min-h-screen bg-white flex flex-col overflow-y-auto">
      {/* Header with back button */}
      <header className="sticky top-0 left-0 right-0 z-20 bg-white px-4 py-4 flex items-center">
        <button className="p-1" onClick={handleBackClick} aria-label="Back">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <div className="w-6"></div> {/* Spacer for alignment */}
      </header>

      {/* Content with padding for header */}
      <div className="px-6 flex-1">
        <div className="max-w-lg mx-auto">
          <h2 className="heading-large text-center mb-8 mt-4">
          How to earn cash back with merchant rewards
          </h2>

          {/* Steps container with light gray background */}
          <div className="rounded-background">
            {/* Step 1 */}
            <div className="mb-8">
              <div className="flex items-start">
                <div className="flex-shrink-0 h-8 w-8 rounded-full bg-black text-white flex items-center justify-center mr-4">
                  1
                </div>
                <div>
                  <h3 className="label-large">Shop online or in-store</h3>
                  <p className="text-gray-600 paragraph-medium">
                  At merchants with available offers
                  </p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="mb-8">
              <div className="flex items-start">
                <div className="flex-shrink-0 h-8 w-8 rounded-full bg-black text-white flex items-center justify-center mr-4">
                  2
                </div>
                <div>
                  <h3 className="label-large">Pay with your credit card</h3>
                  <p className="text-gray-600 paragraph-medium">
                  Only purchases made with this card are eligible for cash back
                  </p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="mb-0">
              <div className="flex items-start">
                <div className="flex-shrink-0 h-8 w-8 rounded-full bg-black text-white flex items-center justify-center mr-4">
                  3
                </div>
                <div>
                  <h3 className="label-large">Earn cash back</h3>
                  <p className="text-gray-600 paragraph-medium">
                  Cash back is credited once eligible transactions are processed
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;